import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';

export const constant = {
	defaultAddress: Enviroment.ADDRESS?.split(',')[0],
};
